const UNDERSCORE_REGEXP = /_\w/g;
const CAMEL_REGEXP = /([a-zA-Z])(?=[A-Z])/g;
const underscoreToCamelReplacer = matches => matches[1].toUpperCase();

export const underscoreToCamel = (str) => {
  if (typeof str !== 'string') {
    return str;
  }

  return str.replace(UNDERSCORE_REGEXP, underscoreToCamelReplacer);
};

export const camelToUnderscore = (str) => {
  if (typeof str !== 'string') {
    return str;
  }

  return str.replace(CAMEL_REGEXP, '$1_').toLowerCase();
};

export function makeTransformationTraversal(keyTransformFunction) {
  return function transformFn(data) {
    if (Array.isArray(data)) {
      return data.map(transformFn);
    } else if (data && data instanceof Object && data.constructor === Object) {
      return Object.keys(data).reduce((acc, key) => {
        acc[keyTransformFunction(key)] = transformFn(data[key]);

        return acc;
      }, {});
    }

    return data;
  };
}

export const underscoreToCamelNested = makeTransformationTraversal(underscoreToCamel);

export const camelToUnderscoreNested = makeTransformationTraversal(camelToUnderscore);
